import { useAppRouter } from '@/common/route/useAppRouter';
import { timeUnits } from '@/common/utils/helpers';
import { validateDateAfter } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useMixins } from '@/modules/promotion/plan/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';
import { useVuelidate } from '@vuelidate/core';
import { minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function usePromotionPlanAdd() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { fetchLinkableItems, linkableItemOption, selectedItemType } = useMixins();

    const beforeFetch = async () => {
        await fetchLinkableItems();
    };

    const model = reactive({
        name: null,
        timeUnit: 0,
        timeDuration: 0,
        publishTime: new Date(),
        unpublishTime: null,
        itemId: null,
        image: null,
        imageFile: null,
        get type() {
            return selectedItemType.value;
        },
        set type(value) {
            this.itemId = null;
            selectedItemType.value = value;
        }
    });

    const validations = {
        name: { required },
        itemId: { required },
        type: { required },
        timeUnit: { required },
        timeDuration: { required, numeric, minValue: minValue(1) },
        publishTime: { required, validateDate: validateDateAfter() }
    };

    const v$ = useVuelidate(validations, model);

    const actions = {
        create: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                promotionService.plan.create(
                    model.name,
                    model.itemId,
                    model.type,
                    model.timeUnit,
                    model.timeDuration,
                    model.publishTime.getTime(),
                    model.unpublishTime?.getTime() ?? null,
                    model.imageFile
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_PROMOTION.PLAN.INDEX })
        })
    };

    return { model, v$, beforeFetch, actions, timeUnits, linkableItemOption, selectedItemType };
}
